import React from 'react';
import PropTypes from 'prop-types';
import Link from 'components/elements/Link';
import ResponsiveImage from 'mui/components/elements/ResponsiveImage';
import {
  StyledBottomCaptionCard,
  StyledGradientEffect,
  StyledCaption,
  StyledResponsiveImage,
} from './DS_BottomCaptionCardStyles';

const DS_BottomCaptionCard = ({ data, children }) => {
  const { cardTitle, cardLink, cardImage, useIllustrationView = false } = data;
  const renderCards = () => {
    return (
      <StyledBottomCaptionCard $illustrated={useIllustrationView}>
        {!useIllustrationView && <StyledGradientEffect></StyledGradientEffect>}

        <StyledResponsiveImage $illustrated={useIllustrationView}>
          <ResponsiveImage {...cardImage} gatsbyImageOptions={{ loading: 'eager' }} />
        </StyledResponsiveImage>

        {children ? (
          <StyledCaption variant="DS_copyMediumBold" $illustrated>
            {children}
          </StyledCaption>
        ) : (
          <StyledCaption variant="DS_copyMediumBold" $illustrated>
            {cardTitle}
          </StyledCaption>
        )}
      </StyledBottomCaptionCard>
    );
  };

  return cardLink ? <Link url={cardLink.url}>{renderCards()}</Link> : renderCards();
};

export default DS_BottomCaptionCard;

DS_BottomCaptionCard.prototype = {
  data: PropTypes.shape({
    id: PropTypes.string.isRequired,
    cardTitle: PropTypes.string,
    cardLink: PropTypes.shape({
      type: PropTypes.string,
      url: PropTypes.string,
    }),
    cardImage: PropTypes.object,
    useIllustrationView: PropTypes.bool,
  }),
};
